export function base64Encode(bytes: Uint8Array): string {
  // base64 encoding:
  // - takes chunks of 3 bytes
  // - concatenates them into 24 bits
  // - chops them back up into 4 pieces of 6 bits
  // - mops each piece's 64 possible values to a character in the base64 alphabet
  // - If we have 1 or 2 bytes left:
  //   - pad the chunk with 0 bits to make a full 24 bit chunk
  //   - emit enough characters to cover all the used bits
  //   - then append '=' for each missing byte.

  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // encode full chunks of 3 bytes to 4 chars
  let i = 0; // bytes index
  let encoded = "";
  while (i < bytes.length - 2) {
    const chunk = (bytes[i++] << 16) | (bytes[i++] << 8) | bytes[i++];
    encoded += chars[(chunk >> 18) & 0x3f];
    encoded += chars[(chunk >> 12) & 0x3f];
    encoded += chars[(chunk >> 6) & 0x3f];
    encoded += chars[chunk & 0x3f];
  }

  // encode last 1 or 2 bytes with padding.
  switch (bytes.length - i) {
    case 1: {
      const chunk = bytes[i] << 16;
      encoded += chars[(chunk >> 18) & 0x3f];
      encoded += chars[(chunk >> 12) & 0x3f];
      encoded += "==";
      break;
    }
    case 2: {
      const chunk = (bytes[i++] << 16) | (bytes[i] << 8);
      encoded += chars[(chunk >> 18) & 0x3f];
      encoded += chars[(chunk >> 12) & 0x3f];
      encoded += chars[(chunk >> 6) & 0x3f];
      encoded += "=";
      break;
    }
  }

  return encoded;
}
